"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _AccordionPanelHeader = _interopRequireDefault(require("./AccordionPanelHeader"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _utils = require("./utils");

var _constants = require("./constants");

var CustomDomainSetupPanels = function CustomDomainSetupPanels(_ref) {
  var activePanelIndex = _ref.activePanelIndex,
      formState = _ref.formState,
      customDomainData = _ref.customDomainData,
      panelStatuses = _ref.panelStatuses,
      handlers = _ref.handlers;
  var inputValue = formState.inputValue,
      error = formState.error,
      isLoading = formState.isLoading,
      isRetryLoading = formState.isRetryLoading;

  var _panelStatuses = (0, _slicedToArray2.default)(panelStatuses, 3),
      firstPanelStatus = _panelStatuses[0],
      secondPanelStatus = _panelStatuses[1],
      thirdPanelStatus = _panelStatuses[2];

  var onCustomURLChange = handlers.onCustomURLChange,
      onCheckAndContinue = handlers.onCheckAndContinue,
      onCopyIntegrationCode = handlers.onCopyIntegrationCode,
      onRetryConnection = handlers.onRetryConnection;
  var resourceRecord = (0, _utils.getResourceRecord)(customDomainData);
  var hasApiData = !!customDomainData;
  var hasResourceRecord = !!resourceRecord;
  var integrationStatus = (0, _utils.getIntegrationStatus)(customDomainData);
  var validationStatus = (0, _utils.getValidationStatus)(customDomainData); // Helper function to create a status badge

  var createStatusBadge = function createStatusBadge(status) {
    return status ? {
      text: status,
      type: status.toLowerCase()
    } : undefined;
  }; // Helper function to create image icons


  var createImageIcon = function createImageIcon(src, height, width, alt) {
    return {
      type: 'image',
      value: (0, _preact.h)("img", {
        height: height,
        width: width,
        src: (0, _absoluteUrlRuntime.resolveUrl)(src),
        alt: alt
      })
    };
  }; // Renders DNS table row based on the current state


  var renderDnsTableRow = function renderDnsTableRow() {
    if (hasApiData && !hasResourceRecord || secondPanelStatus === 'PENDING') {
      return (0, _preact.h)("tr", {
        className: "dns-table__loading-row"
      }, (0, _preact.h)("td", null, (0, _preact.h)("div", {
        className: "dns-table__shimmer dns-table__shimmer--type"
      })), (0, _preact.h)("td", null, (0, _preact.h)("div", {
        className: "dns-table__shimmer dns-table__shimmer--name"
      })), (0, _preact.h)("td", null, (0, _preact.h)("div", {
        className: "dns-table__shimmer dns-table__shimmer--value"
      })));
    }

    if (hasResourceRecord) {
      return (0, _preact.h)("tr", null, (0, _preact.h)("td", null, resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Type), (0, _preact.h)("td", null, resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Name), (0, _preact.h)("td", null, resourceRecord === null || resourceRecord === void 0 ? void 0 : resourceRecord.Value));
    }

    return (0, _preact.h)("tr", null, (0, _preact.h)("td", null, _constants.DNS_TABLE.PLACEHOLDER.Type), (0, _preact.h)("td", null, _constants.DNS_TABLE.PLACEHOLDER.Name), (0, _preact.h)("td", null, _constants.DNS_TABLE.PLACEHOLDER.Value));
  }; // Connection status component


  var ConnectionStatus = function ConnectionStatus(_ref2) {
    var icon = _ref2.icon,
        iconClass = _ref2.iconClass,
        title = _ref2.title,
        description = _ref2.description,
        containerClass = _ref2.containerClass,
        messageClass = _ref2.messageClass,
        contentClass = _ref2.contentClass;
    return (0, _preact.h)("div", {
      className: containerClass
    }, (0, _preact.h)("div", {
      className: messageClass
    }, (0, _preact.h)(_assets.default, {
      icon: icon,
      customClass: iconClass
    }), (0, _preact.h)("div", {
      className: contentClass
    }, (0, _preact.h)("h4", null, title), (0, _preact.h)("p", null, description))));
  }; // DNS configuration content renderer


  var renderDnsConfigurationContent = function renderDnsConfigurationContent() {
    return (0, _preact.h)("div", {
      className: "dns-configuration"
    }, (0, _preact.h)("h4", null, "DNS Instructions"), (0, _preact.h)("p", null, _constants.TEXT_CONTENT.DNS_INSTRUCTIONS), (0, _preact.h)("p", null, _constants.TEXT_CONTENT.CNAME_SETUP_INSTRUCTION), validationStatus === 'FAILED' ? (0, _preact.h)("div", {
      className: "connection-failed"
    }, (0, _preact.h)("div", {
      className: "failed-message"
    }, (0, _preact.h)(_assets.default, {
      icon: "forbidden",
      customClass: "failed-icon"
    }), (0, _preact.h)("div", {
      className: "failed-content"
    }, (0, _preact.h)("h4", null, "DNS Validation Failed"), (0, _preact.h)("p", null, "We couldn't fetch the DNS instructions right now. Please try again shortly, or refresh the page if the issue persists.")))) : (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "dns-table-container"
    }, (0, _preact.h)("table", {
      className: "dns-table ".concat(!hasApiData ? 'dns-table--disabled' : '')
    }, (0, _preact.h)("thead", null, (0, _preact.h)("tr", {
      className: hasApiData && !hasResourceRecord ? 'dns-table__loading-header' : ''
    }, _constants.DNS_TABLE.HEADERS.map(function (header) {
      return (0, _preact.h)("th", {
        key: header
      }, hasApiData && !hasResourceRecord ? (0, _preact.h)("div", {
        className: "dns-table__shimmer dns-table__shimmer--header"
      }) : header);
    }))), (0, _preact.h)("tbody", null, renderDnsTableRow()))), (0, _preact.h)("div", {
      className: "dns-actions"
    }, (0, _preact.h)("div", {
      className: "copy-integration-wrapper"
    }, (0, _preact.h)(_Button.default, {
      title: _constants.BUTTONS.COPY_INTEGRATION.title,
      variant: _constants.BUTTONS.COPY_INTEGRATION.variant,
      onClick: onCopyIntegrationCode,
      size: _constants.BUTTONS.COPY_INTEGRATION.size,
      icon: _constants.BUTTONS.COPY_INTEGRATION.icon,
      disabled: !hasResourceRecord
    })))));
  }; // Connection check content renderer


  var renderConnectionContent = function renderConnectionContent(integrationStatus) {
    var getStatusConfig = function getStatusConfig(status) {
      switch (status) {
        case 'COMPLETED':
          return {
            containerClass: 'connection-success',
            messageClass: 'success-message',
            contentClass: 'success-content',
            icon: 'checkInCircle',
            iconClass: 'success-icon',
            title: 'Connection Established',
            description: _constants.TEXT_CONTENT.CONNECTION_SUCCESS
          };

        case 'FAILED':
          return {
            containerClass: 'connection-failed',
            messageClass: 'failed-message',
            contentClass: 'failed-content',
            icon: 'forbidden',
            iconClass: 'failed-icon',
            title: 'Connection Failed',
            description: _constants.TEXT_CONTENT.CONNECTION_FAILED
          };

        default:
          return {
            containerClass: 'connection-pending',
            messageClass: 'progress-header',
            contentClass: 'progress-content',
            icon: 'clock',
            iconClass: 'progress-icon',
            title: 'Estimated Time : 20 minutes remaining',
            description: _constants.TEXT_CONTENT.CONNECTION_PROGRESS
          };
      }
    };

    var statusConfig = getStatusConfig(integrationStatus);
    var isPending = integrationStatus !== 'COMPLETED' && integrationStatus !== 'FAILED';
    return (0, _preact.h)("div", null, (0, _preact.h)(ConnectionStatus, statusConfig), isPending && (0, _preact.h)("div", {
      className: "retry-connection-wrapper"
    }, (0, _preact.h)(_Button.default, {
      title: _constants.BUTTONS.RETRY_CONNECTION.title,
      variant: _constants.BUTTONS.RETRY_CONNECTION.variant,
      onClick: onRetryConnection,
      size: _constants.BUTTONS.RETRY_CONNECTION.size,
      startIcon: _constants.BUTTONS.RETRY_CONNECTION.icon,
      isLoading: isRetryLoading,
      disabled: isRetryLoading
    })));
  };

  var panels = [// Enter Custom URL Panel
  {
    title: (0, _preact.h)(_AccordionPanelHeader.default, {
      title: _constants.PANEL_CONFIG.ENTER_URL.title,
      leftIcon: createImageIcon(_constants.IMAGE_PATHS.CC_LOGO(), 40, 40, 'Community logo'),
      rightIcon: createImageIcon(_constants.IMAGE_PATHS.AWS_LOGO(), 24, 40, 'AWS logo'),
      statusBadge: createStatusBadge(firstPanelStatus)
    }),
    body: (0, _preact.h)("div", {
      className: "section-content"
    }, (0, _preact.h)(_InputGroup.default, {
      newStyle: true,
      title: "Destination URL",
      type: "text",
      onInput: onCustomURLChange,
      meta: _constants.TEXT_CONTENT.URL_META,
      value: inputValue,
      placeholder: _constants.TEXT_CONTENT.URL_PLACEHOLDER,
      required: true,
      qaClasses: "destination-url-input",
      error: error !== null && error !== void 0 ? error : undefined
    }), (0, _preact.h)("div", {
      className: "section-actions"
    }, (0, _preact.h)(_Button.default, {
      title: _constants.BUTTONS.CHECK_CONTINUE.title,
      variant: _constants.BUTTONS.CHECK_CONTINUE.variant,
      onClick: onCheckAndContinue,
      disabled: !inputValue.trim() || isLoading,
      isLoading: isLoading,
      size: _constants.BUTTONS.CHECK_CONTINUE.size
    }))),
    customClass: _constants.PANEL_CONFIG.ENTER_URL.customClass
  }, // DNS Configuration Panel
  {
    title: (0, _preact.h)(_AccordionPanelHeader.default, {
      title: _constants.PANEL_CONFIG.DNS_CONFIG.title,
      leftIcon: createImageIcon(_constants.IMAGE_PATHS.AWS_LOGO(), 24, 40, 'AWS logo'),
      rightIcon: createImageIcon(_constants.IMAGE_PATHS.DNS_ICON(), 26, 30, 'DNS icon'),
      statusBadge: createStatusBadge(secondPanelStatus)
    }),
    disabled: !hasApiData && secondPanelStatus !== 'PENDING',
    collapsible: hasApiData || secondPanelStatus === 'PENDING',
    body: hasApiData || secondPanelStatus === 'PENDING' ? (0, _preact.h)("div", {
      className: "section-content"
    }, renderDnsConfigurationContent()) : null,
    customClass: _constants.PANEL_CONFIG.DNS_CONFIG.customClass
  }, // Connection Check Panel
  {
    title: (0, _preact.h)(_AccordionPanelHeader.default, {
      title: _constants.PANEL_CONFIG.CONNECTION_CHECK.title,
      leftIcon: createImageIcon(_constants.IMAGE_PATHS.CC_LOGO(), 40, 40, 'Community logo'),
      rightIcon: createImageIcon(_constants.IMAGE_PATHS.DNS_ICON(), 26, 30, 'DNS icon'),
      statusBadge: createStatusBadge(thirdPanelStatus)
    }),
    disabled: !hasApiData || secondPanelStatus !== 'COMPLETED',
    collapsible: hasApiData && secondPanelStatus === 'COMPLETED',
    body: hasApiData && secondPanelStatus === 'COMPLETED' ? (0, _preact.h)("div", {
      className: "section-content"
    }, (0, _preact.h)("div", {
      className: "connection-check"
    }, renderConnectionContent(integrationStatus))) : null,
    customClass: _constants.PANEL_CONFIG.CONNECTION_CHECK.customClass
  }];
  return (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanelIndex,
    panels: panels
  });
};

var _default = CustomDomainSetupPanels;
exports.default = _default;